export default __webpack_public_path__ + "static/beauty-palette-final-7ad10e843a805e4d3f5aa1b8bd47429b.jpg";